export default __webpack_public_path__ + "static/media/2627 knife block A top.a52e7753.png";